import styled from 'styled-components';

export const SelectPatient = styled.div`
.css-13cymwt-control, .css-t3ipsp-control {
    min-height: 54px;
    font: 16px "DM Sans", sans-serif; 
    color: #000000DE
}
.css-1nmdiq5-menu div {
    max-height: 200px;
}
 `